import { createApi } from "@reduxjs/toolkit/query/react";
import { ICaptchaData } from "../../utils/types";
import { baseCaptchaQueryWithLogout } from "../baseQuery";

export const captchaApi = createApi({
  reducerPath: "captchaApi",
  baseQuery: baseCaptchaQueryWithLogout,
  endpoints: (builder) => ({
    getCaptcha: builder.mutation<ICaptchaData, void>({
      query: () => ({
        url: "/captcha/alpha",
        method: "GET",
      }),
    }),
    verifyCaptcha: builder.mutation<any, any>({
      query: (credentials) => ({
        url: "/captcha/validate",
        method: "POST",
        body: credentials?.data,
        headers: {
          Authorization: `Bearer ${credentials?.token}`,
        },
      }),
    }),
  }),
});

export const { useGetCaptchaMutation, useVerifyCaptchaMutation } = captchaApi;
